module.exports = __webpack_public_path__ + "img/main_bg.87ac2750.jpg";